export class ApiRequest {
  filter: Filter;
  sort: Sort;
  pageInfo: PageInfo;
}

export class Filter {
  constructor(composits: FilterComposit[], logicalOperator: string) {
    this.composits = composits;
    this.logicalOperator = logicalOperator;
  }
  composits: FilterComposit[];
  logicalOperator: string;
}

export class FilterComposit {
  constructor(filterPredicates: FilterPredicate [], logicalOperator: string) {
    this.filterPredicates = filterPredicates;
    this.logicalOperator = logicalOperator;
  }
  filterPredicates: FilterPredicate[];
  logicalOperator: string;
}

export class FilterPredicate {
  constructor(propertyName: string, valueTypeName: string,  value: any, predicateOperator: string) {
    this.propertyName = propertyName;
    this.valueTypeName = valueTypeName;
    this.predicateOperator = predicateOperator;
    this.value = value;
  }
  propertyName: string;
  valueTypeName: string;
  predicateOperator: string;
  value: any;
}

export class Sort {
  constructor(conditions: SortCondition[]) {
    this.conditions = conditions;
  }
  conditions: SortCondition[];
}

export class SortCondition {
  constructor(propertyName: string, direction: string) {
    this.propertyName = propertyName;
    this.direction = direction;
  }
  propertyName: string;
  direction: string;
}

export class PageInfo {
  constructor(total: number, page: number, pageSize: number) {
    this.total = total;
    this.page = page;
    this.pageSize = pageSize;
  }
  total: number;
  page: number;
  pageSize: number;
  pageCount: number;
}

export class ApiResponse {
  data: any;
  exceptionType: any;
  isSuccessful: boolean;
  message: string;
  pagingInfo: PageInfo;
  status: number;
}
